import { motion } from "framer-motion";
import { Bell, Search, Command, ShieldCheck } from "lucide-react";
import { useEffect, useState } from "react";

export default function TopBar() {
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);
  return (
    <div className="sticky top-0 z-30 border-b border-white/[0.10] bg-bg-950/60 backdrop-blur-xl shadow-[0_1px_0_rgba(255,255,255,0.04)_inset,0_8px_24px_-12px_rgba(0,0,0,0.6)]">
      <div className="flex items-center gap-4 px-6 py-3.5">
        {/* Search */}
        <div className="flex-1 max-w-md">
          <div className="glass flex items-center gap-2.5 px-3 py-2">
            <Search size={14} className="text-slate-500" />
            <input
              className="bg-transparent border-0 outline-0 flex-1 text-sm placeholder:text-slate-600"
              placeholder="Search services, repos, agents…"
            />
            <kbd className="hidden sm:flex items-center gap-1 px-1.5 py-0.5 rounded bg-white/[0.06] border border-white/[0.06] text-[10px] font-mono text-slate-400">
              <Command size={10} /> K
            </kbd>
          </div>
        </div>

        {/* Status badges */}
        <div className="hidden md:flex items-center gap-2">
          <motion.div
            initial={{ opacity: 0, x: 10 }}
            animate={{ opacity: 1, x: 0 }}
            className="glass px-3 py-1.5 flex items-center gap-2 text-xs"
          >
            <ShieldCheck size={13} className="text-accent-emerald" />
            <span className="font-mono text-slate-400">Entra · Access</span>
          </motion.div>
          <div className="glass px-3 py-1.5 flex items-center gap-2 text-xs font-mono text-slate-400">
            <span className="text-slate-500">UTC</span>
            <span className="tabular-nums text-slate-200">{now.toISOString().slice(11, 19)}</span>
          </div>
        </div>

        <button className="w-9 h-9 rounded-lg bg-white/[0.05] border border-white/[0.10] shadow-[inset_0_1px_0_rgba(255,255,255,0.06)] hover:bg-white/[0.09] hover:border-white/[0.18] hover:-translate-y-px hover:shadow-[0_6px_20px_-10px_rgba(96,165,250,0.4),inset_0_1px_0_rgba(255,255,255,0.10)] flex items-center justify-center">
          <Bell size={15} className="text-slate-300" />
        </button>

        <button className="hidden sm:flex items-center gap-2.5 px-3 py-1.5 rounded-lg border border-white/[0.10] bg-white/[0.05] shadow-[inset_0_1px_0_rgba(255,255,255,0.06)] hover:bg-white/[0.09] hover:border-white/[0.18] hover:-translate-y-px">
          <div className="w-7 h-7 rounded-full bg-gradient-to-br from-accent-blue to-accent-violet flex items-center justify-center text-[11px] font-bold shadow-[inset_0_1px_0_rgba(255,255,255,0.20)]">
            WB
          </div>
          <div className="text-left">
            <div className="text-[12px] leading-tight text-white">Will Bracken</div>
            <div className="eyebrow leading-tight">Owner</div>
          </div>
        </button>
      </div>
    </div>
  );
}
